import { type Action, type AnyAction, combineReducers } from 'redux';

import type { AIAvatar, AIAvatarVoicePreset } from 'js/src/client';
import { aiVoiceFiltersSlice } from 'js/src/data/ai-voices-and-avatars/ai-voice-filters/ai-voice-filters-slice';
import { aiVoicesSlice } from 'js/src/data/ai-voices-and-avatars/ai-voices/ai-voices-slices';
import {
    setAIAvatars,
    setAIAvatarVoicePresets,
    setAIVoiceoverBatchComplete,
} from 'js/src/data/ai-voices-and-avatars/ai-voices-and-avatars-actions';
import StoreORM from 'js/src/data/store-orm';

export function aiAvatarVoicePresets(
    state = StoreORM.newFromIdPrefix<AIAvatarVoicePreset>('ai-avatar-voice-presets').data,
    action: Action,
) {
    if (setAIAvatarVoicePresets.match(action)) {
        const orm = new StoreORM<AIAvatarVoicePreset>(state);
        orm.delete(orm.getAllIds());
        action.payload?.forEach((preset) => orm.pushJSItem(preset, 'id'));
        return orm.data;
    }
    return state;
}

export function aiAvatars(
    state = StoreORM.newFromIdPrefix<AIAvatar>('ai-avatars').data,
    action: Action,
) {
    if (setAIAvatars.match(action)) {
        const orm = new StoreORM<AIAvatar>(state);
        orm.delete(orm.getAllIds());
        action.payload?.forEach((avatar) => orm.pushJSItem(avatar, 'id'));
        return orm.data;
    }
    return state;
}

export function aiVoiceoverBatchComplete(state = false, action: AnyAction) {
    if (setAIVoiceoverBatchComplete.match(action)) {
        return action.payload;
    }
    return state;
}

export const aiVoicesAndAvatars = combineReducers({
    aiVoices: aiVoicesSlice.reducer,
    aiVoiceFilters: aiVoiceFiltersSlice.reducer,
    aiAvatarVoicePresets,
    aiAvatars,
    aiVoiceoverBatchComplete,
});

export type AiVoicesAndAvatarsState = ReturnType<typeof aiVoicesAndAvatars>;
